export default __webpack_public_path__ + "static/media/vector-icon.ae512762.svg";